import apiClient from '../apiClient';

/**
 * Get all orders (Admin/Internal)
 */
const transformOrder = (order) => {
    if (!order) return null;
    const customer = order.customer || {};
    return {
        ...order,
        id: order.publicId, // Frontend expects 'id', backend provides 'publicId'
        customer: {
            ...customer,
            name: customer.name || 'Unknown Customer',
            phone: customer.mobileNumber || customer.whatsappNumber || '',
        },
        salesman: order.assignedSalesPersonName || order.delegatedSalesPersonName || 'Unassigned',
        deliveryDate: order.deliveryDate, // Ensure deliveryDate is explicitly passed
        createdAt: order.createdAt
    };
};

/**
 * Get all orders (Admin/Internal)
 */
export const getOrders = async () => {
    try {
        const response = await apiClient.get('/orders');
        // Backend returns paginated response with content array
        // Extract the array for frontend compatibility
        const data = response.data;
        const orders = Array.isArray(data) ? data : (data.content || []);
        return orders.map(transformOrder);
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

/**
 * Place a new order
 */
export const placeOrder = async (orderData) => {
    try {
        const response = await apiClient.post('/public/orders', orderData);
        return response.data;
    } catch (error) {
        console.error('Error placing order:', error);
        throw error;
    }
};

/**
 * Update an order (using state transitions)
 */
export const updateOrder = async (orderId, updateData) => {
    try {
        // Note: Backend uses state machine transitions
        // This may need adjustment based on backend implementation
        const response = await apiClient.put(`/orders/${orderId}`, updateData);
        return transformOrder(response.data);
    } catch (error) {
        console.error('Error updating order:', error);
        throw error;
    }
};

/**
 * Handle API errors and return user-friendly messages
 */
export const handleApiError = (error) => {
    if (error.response) {
        const status = error.response.status;
        const data = error.response.data;

        switch (status) {
            case 400:
                return data.message || 'Invalid order data. Please check your input.';
            case 401:
                return 'Session expired. Please login again.';
            case 403:
                return 'You do not have permission to perform this action.';
            case 404:
                return 'Resource not found.';
            case 500:
                return 'Server error. Please try again later.';
            default:
                return data.message || 'An error occurred. Please try again.';
        }
    } else if (error.request) {
        return 'Network error. Please check your connection.';
    } else {
        return error.message || 'An unexpected error occurred.';
    }
};
